<div *ngIf="error">
   Invalid confirmation number!<br/>
   Redirecting home...<br/>
</div>

<div class="decision" *ngIf="decision">
   <ng-container [ngSwitch]="decision | lowercase">
      <div *ngSwitchCase="'accept'">
         The transaction has been accepted!<br/>
         <span color="primary">Payment Reference Number</span> {{ref}}<br/>
      </div>
      <div *ngSwitchCase="'cancel'">
         The transaction has been cancelled
      </div>
      <div *ngSwitchCase="'decline'">
         The transaction has been declined
      </div>
      <div *ngSwitchCase="'review'">
         The transaction has been flagged for review
      </div>
      <div *ngSwitchDefault color="warn">
         Cybersource responded with an unknown error<br/>
         Error reference code {{ref}}
      </div>
   </ng-container>

   <div class="email" *ngIf="show_email">
      <mat-form-field class="common-w100perc common-mb1em">
         <input matInput [formControl]="email" placeholder="Email Address" (keyup.enter)="send_button.focus(); check()" />
         <mat-error *ngIf="email.errors">
            <span *ngIf="email.errors.required">Required</span>
            <span *ngIf="email.errors.email">Invalid email</span>
            <span *ngIf="email.errors.fail">Unable to send email</span>
            <span *ngIf="email.errors.message">{{email.errors.message}}</span>
         </mat-error>
      </mat-form-field>
      <button #send_button id="send_button" mat-raised-button color="accent" [disabled]="email.invalid || sending" (click)="check()">Send</button>
      <button mat-button [disabled]="sending" (click)="email.reset(); show_email = false;">Cancel</button>
      <mat-spinner diameter="24" *ngIf="sending" class="common-inlineblock"></mat-spinner>
   </div>

   <div class="buttons">
      <button mat-raised-button color="primary" routerLink="/">
         Make Another Payment
      </button>
      <button mat-raised-button color="primary" *ngIf="!show_email" (click)="show_email = true">
         Email Details
      </button>
   </div>
</div>
